<template>
   <div class='popup'>
      <div class='popup_block'>
         <div class="close" @click="closeModal()"></div>
         <div class=" resume_tariff">
            <div>
               <h1 v-if="!failed">Spasi tenam incha linum</h1>
               <h1 v-else style="color: red">Chi hajoxvel ,Dimeq CvWeb-i jekavarutyany </h1>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
  import cvDownloadMix from "../../../mixins/cvDownload";

  export default {
    data() {
      return {
        order: false,
        redirect_url: '',
        count_check: 0,
        failed: false,
      };
    },
    mixins: [
      cvDownloadMix
    ],
    mounted() {
      this.checkPay();
    },
    methods: {
      closeModal() {
        this.$store.commit('modalBuyLoad', false);
      },
      checkPay() {
        this.count_check++;
        this.$http({
          method: "post",
          url: "/api/check-order",
          data: {
            key: this.$route.params.check_key,
            cv_id: this.$route.params.cv,
            format: this.$route.params.type,
          },
        }).then(res => {
          if (res.data.success) {
            this.$store.commit('modalBuyLoad', false);
            this.downloadFile(this.$route.params.type, res.data.url, res.data.filename);
          } else {
            if (res.data.message === '404') {
              this.$store.commit('modalBuyLoad', false);
              this.$router.push({
                name: 'error_404',
                params: {
                  lang: this.$store.getters.locale
                }
              });
            } else {
              if (this.count_check < 60) {
                setTimeout(this.checkPay, 2000);
              } else {
                this.failed = true;
              }
            }
          }
        });
      },
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/modals/buyTariff/modalBuyLoad.vue